import { Flex } from 'antd';
import styles from './integrations.module.scss';
import { Integrations as IntegrationsModule } from '@modules/integrations';

export const Integrations = () => (
  <Flex className={styles.root}>
    <IntegrationsModule />
  </Flex>
);
